// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-page-container[data-v-127d42ac]{position:relative}h2[data-v-127d42ac]{margin-bottom:0.75rem}@media only screen and (max-width: 959px){h2[data-v-127d42ac]{margin-top:3.5625rem}}.product-section-content[data-v-127d42ac]{margin:2.25rem 0}", ""]);
// Exports
module.exports = exports;
